import { render, staticRenderFns } from "./BasicDropdown.vue?vue&type=template&id=64918836&scoped=true&"
import script from "./BasicDropdown.vue?vue&type=script&lang=js&"
export * from "./BasicDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BasicDropdown.vue?vue&type=style&index=0&id=64918836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64918836",
  null
  
)

export default component.exports